import React from 'react';

export const ArrowLeftTailIcon = ({ fill = '#3698FC', ...props }: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.4939 20.5644C11.1821 20.8372 10.7083 20.8056 10.4356 20.4939L3.43557 12.4939C3.18814 12.2111 3.18814 11.7889 3.43557 11.5061L10.4356 3.50611C10.7083 3.19438 11.1822 3.1628 11.4939 3.43556C11.8056 3.70832 11.8372 4.18214 11.5644 4.49387L5.65283 11.25L20 11.25C20.4142 11.25 20.75 11.5858 20.75 12C20.75 12.4142 20.4142 12.75 20 12.75L5.65283 12.75L11.5644 19.5061C11.8372 19.8178 11.8056 20.2917 11.4939 20.5644Z"
        fill={fill}
      />
    </svg>
  );
};
